// extracted by mini-css-extract-plugin
export default {"loginFormWrapper":"login_loginFormWrapper__QXiPT","noSocialButtons":"login_noSocialButtons__kFVZM"};